/**
 * Entrada da landing web-app (/radio/app-landing/…), página server-rendered fora da SPA.
 *
 * Substitui os <script> que o app-landing.php carregava: favorite-radio-payload.js,
 * music-identifier.js (Shazam via import dinâmico) e app-landing-player.js.
 * Build com nome estável: bundle/app-landing.js (ver vite.config.ts).
 */
import { initFavoriteRadioPayload } from "./lib/favoriteRadioPayload";
import { initMusicIdentifier } from "./lib/musicIdentifier";
import { initAppLandingPlayer } from "./lib/appLandingPlayer";

function boot(): void {
  initFavoriteRadioPayload();
  // O player procura window.MusicIdentifier ao iniciar o Shazam: registrar antes.
  initMusicIdentifier();
  initAppLandingPlayer();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
